import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"
import "@fontsource/ibm-plex-mono/700.css"
import "@fontsource/ibm-plex-mono/400-italic.css"
// Includes Preflight, which replaces normalize.css -- no separate
// normalize import needed.
import "./src/styles/global.css"

import "prismjs/themes/prism.css"
import "./src/styles/prism-light.css"
import "./src/styles/prism-dark.css"

import { watchSystemTheme } from "./src/theme"
import { refreshScrollableRegions, watchScrollableRegions } from "./src/utils/scrollable-regions"
import { refreshMermaidAccessibility } from "./src/utils/mermaid-accessibility"

const CTA_ANCHOR_ID = "compare-notes-with-us"
const CTA_EVENT_NAME = "cta_click"
const CTA_EVENT_CATEGORY = "harness_model_cta"

const ctaLabelForHref = href => {
  if (!href) return null
  if (href.startsWith("mailto:")) return "email"
  if (href.includes("linkedin.com/in/maciej-laskowski")) return "linkedin_maciek"
  if (href.includes("linkedin.com/in/tomaszmichalak")) return "linkedin_tomek"
  return null
}

const tagCtaLinks = () => {
  const heading = document.getElementById(CTA_ANCHOR_ID)
  if (!heading) return
  let node = heading.nextElementSibling
  while (node && node.tagName !== "H2") {
    node.querySelectorAll("a[href]").forEach(a => {
      const label = ctaLabelForHref(a.getAttribute("href"))
      if (label && a.dataset.ctaTrack !== label) {
        a.dataset.ctaTrack = label
      }
    })
    node = node.nextElementSibling
  }
}

const sendCtaEvent = (label, href) => {
  const payload = {
    event_category: CTA_EVENT_CATEGORY,
    event_label: label,
    link_url: href,
    page_location: window.location.href,
    transport_type: "beacon",
  }
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", CTA_EVENT_NAME, payload)
      return
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: CTA_EVENT_NAME, ...payload })
    }
  } catch (_) {
  }
}

const handleCtaClick = event => {
  const link = event.target.closest && event.target.closest("a[data-cta-track]")
  if (!link) return
  sendCtaEvent(link.dataset.ctaTrack, link.getAttribute("href"))
}

export const onClientEntry = () => {
  document.addEventListener("click", handleCtaClick, true)
  // Initial theme paint is already handled by gatsby-ssr.ts's blocking
  // script -- this only syncs an unset preference when the OS flips.
  watchSystemTheme()
  // Resize-driven overflow changes are independent of navigation --
  // installed once here; onRouteUpdate (below) handles navigation.
  watchScrollableRegions()
}

export const onRouteUpdate = () => {
  tagCtaLinks()
  refreshScrollableRegions()
  refreshMermaidAccessibility()
}
